import { render, staticRenderFns } from "./CampaignStatusTable.vue?vue&type=template&id=b90b71de&scoped=true&"
import script from "./CampaignStatusTable.vue?vue&type=script&lang=js&"
export * from "./CampaignStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatusTable.vue?vue&type=style&index=0&id=b90b71de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90b71de",
  null
  
)

export default component.exports